import { Trees } from "lucide-react";

const AppLogo = () => {
    return (
        <div className="flex items-center gap-2 py-6">
            <Trees />
            <span className="text-2xl font-semibold">Shamba ODK</span>
        </div>
    );
}

export default AppLogo;
